<template>
	<div class="about">
		<v-header />
		<v-sidebar />
		<div class="content-box" :class="{ 'content-collapse': collapse }">
			<v-tags v-if="showTagsView"></v-tags>
			<div class="content">
				<router-view v-slot="{ Component }">
					<keep-alive :include="tagsList">
						<component :is="Component" />
					</keep-alive>
				</router-view>
			</div>
		</div>
		<v-footer v-if="showFooter" />
	</div>
</template>
<script>
	import vHeader from '../../components/Header';
	import vSidebar from '../../components/Sidebar';
	import vTags from '../../components/Tags.vue';
	import vFooter from '../../components/Footer.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			vHeader,
			vSidebar,
			vTags,
			vFooter
		},
		computed: {
			...mapState('app', ['showTagsView', 'showFooter']),
			tagsList() {
				return this.$store.state.tagsList.map(item => item.name);
			},
			collapse() {
				return this.$store.state.collapse;
			}
		}
	};
</script>